export default __webpack_public_path__ + "static/media/arras05.c833ad9e.jpg";